export default __webpack_public_path__ + "static/media/africa_text.a5d1269e.png";